import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GoogleAnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if gtag is defined (it's added to index.html)
    if (window.gtag) {
      window.gtag('config', 'G-5GF1BTLJ5B', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
};

export default GoogleAnalyticsTracker;
